import { render, staticRenderFns } from "./CandidateBubble.vue?vue&type=template&id=caffe9d8&"
import script from "./CandidateBubble.vue?vue&type=script&lang=ts&"
export * from "./CandidateBubble.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports